import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { routes } from '../../app-routing.module';
import { Title } from '@angular/platform-browser';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthSessionService } from '../../auth/auth-session.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  routes = routes.filter(route => !route.data?.hideNav);

  constructor(
    public titleService: Title,
    private breakpointObserver: BreakpointObserver,
    private oauthService: OAuthService,
    private authSession: AuthSessionService,
  ) {
  }

  logout() {
    this.authSession.logout();
  }

  isLoggedIn() {
    return this.oauthService.getAccessToken() != null;
  }

  getUsername() {
    return this.oauthService.getIdentityClaims()?.preferred_username;
  }
}
